/* eslint-disable no-use-before-define */
import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static values = {
    minutesLeft: Number,
    timerDisplayId: {
      type: String,
      default: 'timer-display',
    },
  };

  connect() {
    this.startTiming();
  }

  startTiming() {
    this.timer = startTimer(this.minutesLeftValue * 60, this.timerDisplayIdValue, () => {
      // eslint-disable-next-line no-alert
      this.countDownFinished('You will be shown the data a few moments from now');
    });
  }

  pauseCounting() {
    this.timer.pause();
  }

  countDownFinished() {
    this.timer.showGenericTimeOverMessage();
  }
}

const startTimer = (seconds, container, oncomplete) => {
  let startTime;
  let timer;
  const obj = {};
  let ms = seconds * 1000;
  const display = document.getElementById(container);

  obj.resume = () => {
    startTime = new Date().getTime();
    timer = setInterval(obj.step, 250);
  };

  obj.pause = () => {
    ms = obj.step();
    clearInterval(timer);
  };

  obj.step = () => {
    const now = Math.max(0, ms - (new Date().getTime() - startTime));
    const m = Math.floor(now / 60000);
    let s = Math.floor(now / 1000) % 60;

    s = (s < 10 ? '0' : '') + s;
    display.innerHTML = `about ${m}:${s}`;
    if (now === 0) {
      clearInterval(timer);
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      obj.resume = () => {};
      if (oncomplete) oncomplete();
    }
    return now;
  };

  obj.pluralMinutes = (m) => {
    if (m === 1) {
      return 'minute';
    }
    return 'minutes';
  };

  obj.showGenericTimeOverMessage = () => {
    display.innerHTML = 'a few moments';
  };

  obj.resume();

  return obj;
};
